module.exports = __webpack_public_path__ + "img/fragmanted-value-chain-min.1ca7d914.jpg";